var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div style=\"padding: 16px; text-align: center;\" ng-if=\"vm.show\"><div id=\"qr-inner\" ng-if=\"!vm.error\"></div><div ng-if=\"vm.error\" style=\"color: red; margin-top: 8px;\">Failed to generate QR code.</div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/account/qrcode/qrcode.jade
 ** module id = 600
 ** module chunks = 0
 **/